import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface CommonModalProps {
  id: string;
  title: string;
  size?: 'sm' | 'lg' | 'xl'; // Note: 'md' is default and not needed explicitly
  centered?: boolean;
  children: React.ReactNode;
  visible?: boolean;
  onClose?: () => void;
  footer?: React.ReactNode;
}

const CommonModal: React.FC<CommonModalProps> = ({
  id,
  title,
  size = 'lg',
  centered = true,
  children,
  visible = false,
  onClose,
  footer,
}) => {
  return (
    <Modal
      id={id}
      show={visible}
      onHide={onClose}
      size={size}
      centered={centered}
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default CommonModal;
